import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { money } from "@/lib/format";
import { useBrand } from "@/context/BrandContext";
import { Lightning, ShieldCheck, GlobeHemisphereEast, Gift, ArrowRight } from "@phosphor-icons/react";
import { WhatsAppFab } from "@/components/WhatsAppFab";

export default function QuickBuy() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const brand = useBrand();
  const ref = params.get("ref") || "";
  const [recipient, setRecipient] = useState("");
  const [bonus, setBonus] = useState(0);

  useEffect(() => {
    api.get("/settings/public").then(({ data }) => { if (data.referral_enabled) setBonus(data.referral_bonus_cents || 0); }).catch(() => {});
  }, []);

  const go = () => {
    try { localStorage.setItem("iyeneh_buy_intent", JSON.stringify({ recipient: recipient.trim() })); } catch {}
    navigate(ref ? `/register?ref=${encodeURIComponent(ref)}` : "/register");
  };

  const benefits = [
    { icon: Lightning, t: "Instant airtime", d: "Top up any Cameroon number in seconds — MTN, Orange & more." },
    { icon: GlobeHemisphereEast, t: "181 countries", d: "Send data, airtime and pay bills across the globe." },
    { icon: ShieldCheck, t: "Safe & secure", d: "One wallet, encrypted checkout, instant receipts." },
  ];

  return (
    <div className="min-h-screen bg-[#08111F] text-white" data-testid="quickbuy-page">
      <div className="mx-auto max-w-md px-5 py-10">
        <div className="flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary"><span className="font-display font-bold">I</span></div>
          <span className="font-display text-lg font-semibold">{brand.brand_name}</span>
        </div>

        {ref && bonus > 0 && (
          <div className="mt-6 flex items-center gap-2 rounded-full bg-primary/15 px-4 py-2 text-sm font-semibold text-primary" data-testid="quickbuy-bonus">
            <Gift size={16} weight="fill" /> You've been invited — get {money(bonus, "USD")} free credit
          </div>
        )}

        <h1 className="mt-5 font-display text-4xl font-semibold leading-tight tracking-tight">Send data, airtime, top-up credit to friends &amp; family Worldwide in Seconds</h1>
        <p className="mt-3 text-white/60">Create a free account, add funds once, and send top-ups to any number — anytime, from your phone.</p>

        <label className="mt-6 block text-xs font-semibold uppercase tracking-wide text-white/50">Recipient number (optional)</label>
        <input data-testid="quickbuy-recipient" value={recipient} onChange={(e) => setRecipient(e.target.value)} placeholder="+237 6XX XXX XXX"
          className="mt-1.5 w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 outline-none focus:border-primary" />

        <button data-testid="quickbuy-cta" onClick={go}
          className="mt-4 flex w-full items-center justify-center gap-2 rounded-full bg-primary py-4 font-semibold text-primary-foreground transition-transform hover:scale-[1.02]">
          {ref && bonus > 0 ? `Claim ${money(bonus, "USD")} & get started` : "Get started free"} <ArrowRight size={18} weight="bold" />
        </button>

        <div className="mt-8 space-y-3">
          {benefits.map((b) => (
            <div key={b.t} className="flex items-start gap-3 rounded-2xl border border-white/10 bg-white/[0.03] p-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/20 text-primary"><b.icon size={20} weight="duotone" /></div>
              <div><p className="font-semibold">{b.t}</p><p className="text-sm text-white/50">{b.d}</p></div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-center text-xs text-white/40">Already have an account? <button onClick={() => navigate("/login")} className="font-semibold text-primary">Sign in</button></p>
      </div>
      <WhatsAppFab />
    </div>
  );
}
